module.exports = "https://cdn.dove.it/_next/static/public/assets/landings/franchising/vantaggio_entry_fee.31cc02a81e812b7de0a5766ecd9e3503.jpg";